import { AppSessionContext } from '../../Services/Services.Primary/SessionContext/AppSessionContext';
import TelemetryService from '../../Services/Services.Primary/Telemetry/TelemetryService';
import BrowserStorage from '../../Services/Services.Secondary/BrowserStorage';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';
import { SupportPanelState } from './Models/SupportPanelState';
import { SupportTopic } from './Models/SupportTopic';
import { Constants } from './Constants';
import CreateTicketFlowContainer, { CreateState } from './CreateTicketFlowContainer';
import InfoView from './InfoView';
import { ServiceRequest } from './Models/ServiceRequest';
import { Helper } from './Utilities/Helper';
import NextStepView from './NextStepView';

let resx = LocalizationService.getInstance();
let sessionContext = AppSessionContext.getInstance();
let browserStorage = BrowserStorage.getInstance();
let Constant = Constants.getInstance();
let tracingService = TelemetryService.getInstance();
let BackToHomePageButton_text = resx.getLocalizedResource('BackToHomePageButton_text');
let ProvideIssueDetails_text = resx.getLocalizedResource('ProvideIssueDetails_text');
let ReturnToHomepage_html_text = resx.getLocalizedResource('ReturnToHomepage_html_text');
let CreateAsGuestUser_html_text = resx.getLocalizedResource('CreateAsGuestUser_html_text');
let ProvideIssueDetailsButton_text = resx.getLocalizedResource('ProvideIssueDetailsButton_text');
let SigninProvideIssueDetailsButton_text = resx.getLocalizedResource('SigninProvideIssueDetailsButton_text');

export default class CreateTicketFlowContainerUnauth extends CreateTicketFlowContainer {
  constructor(props: any) {
    super(props);
    this.containerOuterClass = 'row flexWrapperRow publicOuterClass';
    this.containerInnerStyle = { maxWidth: '1600px', height: '100%', margin: '0 auto', padding: '0' };
    this.pageWrapperOverflowY = 'hidden';
    this.pageWrapperPaddingTop = '';
    this.supportHeaderClassName = 'page-title-header-support-public-page';
    this.isSupportPublicRoute = true;
    this.workspaceView = false;
  }

  setBasicsRoute = () => {
    window.history.pushState(null, 'change to stage 1', `${'?stage=1' + this.origQueryString}`);
  };

  setSolutionRoute = (issueType: SupportTopic = this.state.issueType) => {
    window.history.pushState(
      null,
      'change to stage 2',
      `${`?stage=2&topicid=${issueType.id}${this.origQueryString}`}`
    );
  };

  setDetailsRoute = (issueType: SupportTopic = this.state.issueType) => {
    window.history.pushState(
      null,
      'change to stage 3',
      `${`?stage=3&topicid=${issueType.id}${this.origQueryString}`}`
    );
  };

  setConfirmationRoute = () => {
    window.history.pushState(null, 'change to stage 4', `${`?stage=4${this.origQueryString}`}`);
  };

  setDetailQueryString = (): void => {
    this.origQueryString = this.origQueryString + '&' + Constant.QueryStringParams.unauthRedirect + '=true';
  };

  cancel = () => {
    sessionContext.resetTicketTrackingId();
    this.setBasicsState();
  };

  blockPcCreationByProgramClaim = (): boolean => {
    return false;
  };

  getSolutionBackButton = (): JSX.Element => {
    if (this.isContinueDisabled()) {
      return (
        <button className="spacer-ms-top btn-primary" onClick={this.cancelCreateTicketSolutionStep}>
          {BackToHomePageButton_text}
        </button>
      );
    }
    return <></>;
  };

  getSolutionNextStepDiv = (issueType: SupportTopic, serviceRequestsWithTopicId: ServiceRequest[]) => {
    return (
      <div className="flexShrink0">
        <InfoView>
          <NextStepView
            ProvideIssueDetailDiv={this.getProvideIssueDetailDiv(
              issueType,
              this.state.serviceRequestsWithTopicId ?? []
            )}
            ContinueDiv={this.getContinueDiv()}
          />
        </InfoView>
      </div>
    );
  };

  private getProvideIssueDetailDiv = (issueType: SupportTopic, serviceRequestsWithTopicId: ServiceRequest[]) => {
    return (
      <div style={{ marginBottom: '7px' }}>
        <p className="solution-details-text">{ProvideIssueDetails_text}</p>
        <p style={{ fontSize: '15px', display: 'inline-block' }}>&nbsp;</p>
        <div
          style={{ fontSize: '15px', display: 'inline-block' }}
          onClick={this.cancelCreateTicketSolutionStep}
          dangerouslySetInnerHTML={{ __html: ReturnToHomepage_html_text }}
        />
      </div>
    );
  };
  private getContinueDiv = () => {
    if (this.isStepRequireAuth('Details', this.state.issueType) && this.isGuestMode()) {
      return (
        <div>
          <button className="btn-primary" style={{ marginBottom: '24px' }} onClick={this.continueSolutionStep}>
            {this.getProvideDetailsText()}
          </button>
          <div
            style={{ fontSize: '15px' }}
            onClick={this.guestModeClick}
            dangerouslySetInnerHTML={{ __html: CreateAsGuestUser_html_text }}
          />
        </div>
      );
    } else {
      return (
        <button className="btn-primary" style={{ marginBottom: '20px' }} onClick={this.continueSolutionStep}>
          {this.getProvideDetailsText()}
        </button>
      );
    }
  };

  private isGuestMode = (): boolean => {
    return (
      (!this.isContinueDisabled() &&
        this.state.issueType.metadata &&
        this.state.issueType.metadata.allowGuestTicketCreationInPC &&
        this.state.issueType.metadata.allowGuestTicketCreationInPC.indexOf('Unblocked') > -1) ??
      false
    );
  };

  private setGuestMode = (issueType: SupportTopic = this.state.issueType) => {
    this.setDetailsRoute(issueType);
    this.setState({
      screenState: CreateState.Details,
      issueType: issueType,
      issueTitle: this.getParentTopicNameById(issueType.id) ?? '',
      loading: false,
    });
  };

  private guestModeClick = () => {
    let eventName = Constant.actionTypes.guestContinue;
    tracingService.traceEvent(eventName, {});
    this.setGuestMode(this.state.issueType);
  };

  setDetailsState = async (issueType: SupportTopic = this.state.issueType) => {
    if (!this.isStepRequireAuth('Unauthenticated', issueType)) {
      this.setDetailQueryString();

      Helper.setPublicDeepLinkInfo(
        issueType.id,
        SupportPanelState.detail,
        this.state.verbatim,
        sessionContext.TicketTrackingId,
        browserStorage,
        tracingService
      );

      let newUrl =
        window.location.origin +
        '/dashboard/v2/support/' +
        this.createRoute +
        '?stage=3&topicid=' +
        issueType.id +
        this.origQueryString +
        '&ticketTrackingId=' +
        sessionContext.TicketTrackingId +
        this.getVerbatimQueryString();

      tracingService.traceEvent(Constant.actionTypes.unAuthRedirectToDashboardEvent, {
        newUrl: newUrl,
        issueType: issueType,
      });

      window.location.href = newUrl;
    } else {
      this.setDetailsRoute(issueType);

      tracingService.traceEvent(Constant.actionTypes.unAuthProceedToIssueDetailsEvent, {
        issueType: issueType,
      });

      this.setState({
        screenState: CreateState.Details,
        issueType: issueType,
        issueTitle: this.getParentTopicNameById(issueType.id) ?? '',
        loading: false,
      });
    }
  };

  getProvideDetailsText = (): string => {
    if (!this.isStepRequireAuth('Unauthenticated', this.state.issueType)) {
      return SigninProvideIssueDetailsButton_text;
    } else {
      return ProvideIssueDetailsButton_text;
    }
  };
}
